import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { MsalService } from 'src/app/msal/msal.service';
import { UsersService } from 'src/app/service/users.service';
import { TaskManagerStateService } from 'src/app/service/taskmanager-state.service';
import { environment } from "../../../environments/environment";
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: false,  // NOSONAR
})
export class HeaderComponent implements OnInit, OnDestroy {
	constants: Constants = new Constants()
	navlinks = this.constants.navLinkItems;
	userName: any = '';
	getRole = { "name": "", "user_role": "", "role_1": '', "role_2": '' };
	rolesArray = [];
	selectedRole;
	userInfo;

	show: boolean = false;
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;

	constructor(private readonly authService: MsalService, private readonly userService: UsersService, private readonly state: TaskManagerStateService, private readonly versionCheckService: VersionCheckService) { }

	ngOnInit(): void {
		this.subscription = this.state.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				this.userName = localStorage.getItem('name');
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if (roles?.length) {
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
		this.versionCheckService.initVersionCheck();
	}

	getrole(i) {
		this.selectedRole = this.rolesArray[i];
		console.info("the selected role", i, this.selectedRole);
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace(environment.LOGOUT_REDIRECT_URL);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
